// Hiring document template types (per Mudassir's Jul-15 "Document Template
// Repository" handoff). These are a SUBSET of the main hiring document enum,
// which is why Contract is 19 (do NOT renumber). The template repository GET
// also returns displayName for each slot, so the page reads labels from the
// API; this mapping is kept for label fallback and any type-specific handling
// (e.g. HR Policy, which is auto-referenced in the applicant flow).
export const HiringDocumentType = Object.freeze({
  OfferLetter: 0,
  NDA: 1,
  NCA: 2,
  EmployeeAgreement: 3,
  HRPolicy: 4,
  I9: 5,
  W4: 6,
  W9: 7,
  Contract: 19,
});

export const HiringDocumentTypeLabel = Object.freeze({
  [HiringDocumentType.OfferLetter]: "Offer Letter",
  [HiringDocumentType.NDA]: "NDA",
  [HiringDocumentType.NCA]: "NCA",
  [HiringDocumentType.EmployeeAgreement]: "Employee Agreement",
  [HiringDocumentType.HRPolicy]: "HR Policy",
  [HiringDocumentType.I9]: "I-9",
  [HiringDocumentType.W4]: "W-4",
  [HiringDocumentType.W9]: "W-9",
  [HiringDocumentType.Contract]: "Contract",
});

// Allowed template upload formats (handoff section 11).
export const TEMPLATE_ALLOWED_EXTENSIONS = [".pdf", ".doc", ".docx"];
